import React, { FC, useEffect } from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import config from './config'
import utils from '../../../../../components/Organisms/Form/utils'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'

import { FormProps } from '../../../../Pages/Onboarding/types'

const ExperienceForm: FC<FormProps> = props => {
  const submitForm = ({data, options}: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options })
  }
  const {
    formData,
    setFormData,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
    toggleShowByVisualName,
    toggleShowBySecondaryName,
    configData,
  } = useForm(
    props.fetchedData,
    config(),
    submitForm
  )

  useEffect(() => {
    toggleShowByVisualName(
      'companyTreasuryLabelInputFiles',
      formData?.eTradersExperience?.value === 'companyTreasury' ? 'true' : 'false'
    )
    toggleShowByVisualName(
      'companyTreasuryInputFilesComponent',
      formData?.eTradersExperience?.value === 'companyTreasury' ? 'true' : 'false'
    )

    toggleShowByVisualName(
      'companyCommitteeLabelInputFiles',
      formData?.eTradersExperience?.value === 'companyCommittee' ? 'true' : 'false'
    )
    toggleShowByVisualName(
      'companyCommitteeInputFilesComponent',
      formData?.eTradersExperience?.value === 'companyCommittee' ? 'true' : 'false'
    )

    toggleShowByVisualName(
      'companyAlgorithmsLabelInputFiles',
      formData?.eTradersExperience?.value === 'companyAlgorithms' ? 'true' : 'false'
    )
    toggleShowByVisualName(
      'companyAlgorithmsInputFilesComponent',
      formData?.eTradersExperience?.value === 'companyAlgorithms' ? 'true' : 'false'
    )

    // @ts-ignore
    if(!formData.noOfQualifiedProfessionals.value || (Array.isArray(formData.traderExperienceForms?.value) && formData.traderExperienceForms?.value.length > parseInt(formData.noOfQualifiedProfessionals.value) + 1)) {
      setFormData(prev => {
        // @ts-ignore
        Array.isArray(prev?.traderExperienceForms?.value) && prev?.traderExperienceForms?.value?.length > 0 && prev?.traderExperienceForms?.value?.splice(!formData.noOfQualifiedProfessionals.value ? 0 : parseInt(formData.noOfQualifiedProfessionals.value) + 1)
        return prev
      })
    }

    if(!['companyTreasury', 'companyCommittee', 'companyAlgorithms'].includes(formData.eTradersExperience.value)){
      setFormData(prev => ({...prev, noOfQualifiedProfessionals: { ...prev.noOfQualifiedProfessionals, value: '' } }))
    }

  }, [formData?.eTradersExperience?.value])

  useEffect(() => {

    toggleShowBySecondaryName(
      'noOfQualifiedProfessionals',
      formData?.eTradersExperience?.value !== '' && `${formData?.eTradersExperience?.value}HowMany`
    )

    toggleShowBySecondaryName(
      'entityName',
      formData?.eTradersExperience?.value !== '' && ['companyExternal','companyRelatedEntity'].includes(formData?.eTradersExperience?.value) ? `${formData?.eTradersExperience?.value}EntityName` : ''
    )
    toggleShowBySecondaryName(
      'lei',
      formData?.eTradersExperience?.value !== '' && ['companyExternal','companyRelatedEntity'].includes(formData?.eTradersExperience?.value) ? `${formData?.eTradersExperience?.value}Lei` : ''
    )

    toggleShowByVisualName(
      'companyExternalLabelEntityNameLei',
      formData?.eTradersExperience?.value === 'companyExternal' ? 'true' : 'false'
    )

    toggleShowByVisualName(
      'companyRelatedEntityLabelEntityNameLei',
      formData?.eTradersExperience?.value === 'companyRelatedEntity' ? 'true' : 'false'
    )

  }, [formData?.eTradersExperience?.value])

  useEffect(() => {
    toggleShowByVisualName(
      'haveEvidenceLabelInputFiles',
      formData?.isEvidencesDocumentationProvided?.value === 'false' ? 'true' : 'false'
    )
    toggleShowByVisualName(
      'haveEvidenceInputFilesComponent',
      formData?.isEvidencesDocumentationProvided?.value === 'false' ? 'true' : 'false'
    )
  }, [formData?.isEvidencesDocumentationProvided?.value])

  useEffect(() => {
    setFormData(prev => {
      // @ts-ignore:next-line
      if(prev.traderExperienceForms?.value?.length < (parseInt(formData.noOfQualifiedProfessionals?.value) + 1)) {
      /* eslint-disable  @typescript-eslint/no-unused-vars */
        const nullFilesArray = [...Array((parseInt(formData.noOfQualifiedProfessionals.value) + 1) - prev.traderExperienceForms.value.length).keys()].map(item => ({
          /* eslint-enable  @typescript-eslint/no-unused-vars */
          documentFileExtension: null,
          documentFileType: null,
          documentID: 0,
          documentName: null,
          documentSection: null,
          documentType: null,
        }))
        // @ts-ignore:next-line
        const addedFilesArray = prev.traderExperienceForms.value.concat(nullFilesArray)
        prev.traderExperienceForms = {
          ...prev.traderExperienceForms,
          value: addedFilesArray
        }
      } else if(prev.traderExperienceForms?.value?.length > (parseInt(formData.noOfQualifiedProfessionals?.value) + 1)) {
        const indexToRemoveFrom = parseInt(formData.noOfQualifiedProfessionals?.value) + 1
        // @ts-ignore
        prev.traderExperienceForms?.value?.splice?.(indexToRemoveFrom)
      }
      return {...prev, numberOfFiles: {
        value: (parseInt(formData.noOfQualifiedProfessionals?.value) + 1).toString()
      }
      }
    })
  }, [formData.noOfQualifiedProfessionals.value])

  useEffect(() => {
    // @ts-ignore
    setFormData(prev => {
      // @ts-ignore
      if(prev?.traderExperienceForms?.value && prev.traderExperienceForms.value.constructor === Object && prev.traderExperienceForms.value.documentName === null) prev.traderExperienceForms.value = []
      // @ts-ignore
      if(prev.evidences.value.constructor === Object && prev.evidences.value.documentName === null) prev.evidences.value = []

      return prev
    })
  },[])

  useEffect(() => {

    toggleShowByVisualName(
      'pleaseConfirm',
      formData.isFund.value === 'true' ? 'true' : 'false'
    )

    toggleShowByName(
      'isFundEntity',
      formData.isFund.value === 'true'
    )

    toggleShowByName(
      'isFundLei',
      formData.isFund.value === 'true'
    )

  },[formData.isFund.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.ExperienceForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.ExperienceForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={formData.isEvidencesDocumentationProvided.value === ''
              || !['companyTreasury', 'companyCommittee', 'companyAlgorithms', 'companyExternal', 'companyRelatedEntity', 'companyRegulated'].includes(formData.eTradersExperience.value)
              || (['companyTreasury', 'companyCommittee', 'companyAlgorithms'].includes(formData.eTradersExperience.value) && formData.traderExperienceForms.value?.length === 0)
              || (formData.isEvidencesDocumentationProvided.value === 'false' && formData.evidences.value?.length === 0)
              || (
                ['companyTreasury', 'companyCommittee', 'companyAlgorithms'].includes(formData.eTradersExperience.value) &&
                  formData.traderExperienceForms.value?.length > 0 &&
                  // @ts-ignore:next-line
                  formData.traderExperienceForms.value.some(doc => doc.documentName === null)
              )
              || (
                formData.isEvidencesDocumentationProvided.value === 'false' &&
                  formData.evidences.value?.length > 0 &&
                  // @ts-ignore:next-line
                  formData.evidences.value.some(doc => doc.documentName === null)
              )
              || (
                ['companyExternal', 'companyRelatedEntity'].includes(formData.eTradersExperience.value) &&
                (formData.lei.value === '' || formData.entityName.value === '')
              )
              || formData.isFund.value === ''
              || (
                formData.isFund.value === 'true' &&
                (formData.isFundEntity.value === '' || formData.isFundLei.value === '')
              )
            }
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default ExperienceForm
